module.exports = __webpack_public_path__ + "img/02.a096e0e9.png";